import { request, METHOD } from '@/utils/request'

const meetingApi = {
  // 会议室管理
  saveRoom: (data) => request('/meeting/saveRoom', METHOD.POST, data),
  queryRoomList: (params) => request('/meeting/queryRoomList', METHOD.POST, params || {}),
    manageRoomList: (params) => request('/meeting/manageRoomList', METHOD.POST, params || {}),
  queryRoomDetail: (data) => request('/meeting/queryRoomDetail', METHOD.POST, data),
  deleteRoom: (data) => request('/meeting/deleteRoom', METHOD.POST, data),
  
  // 预约管理
  saveReservation: (data) => request('/meeting/saveReservation', METHOD.POST, data),
  queryReservationList: (params) => request('/meeting/queryReservationList', METHOD.POST, params || {}),
  queryMyReservationList: (params) => request('/meeting/queryMyReservationList', METHOD.POST, params || {}),
  queryReservationDetail: (data) => request('/meeting/queryReservationDetail', METHOD.POST, data),
  cancelReservation: (data) => request('/meeting/cancelReservation', METHOD.POST, data),
  submitReservation: (data) => request('/meeting/submitReservation', METHOD.POST, data),
  
  // 审批管理
  approve: (data) => request('/meeting/approve', METHOD.POST, data),
  queryApprovalList: () => request('/meeting/queryApprovalList', METHOD.POST),
  queryMyFinishedAndToDoList: (params) => request('/meeting/queryMyFinishedAndToDoList', METHOD.POST, params),
  
  // 任务管理
  handleTask: (data) => request('/meeting/handleTask', METHOD.POST, data),
  queryTaskList: () => request('/meeting/queryTaskList', METHOD.POST),
  completeTask: (data) => request('/meeting/completeTask', METHOD.POST, data),
  queryTaskManagementList: (params) => request('/meeting/queryTaskManagementList', METHOD.POST, params),
  
  // 文件上传
  uploadImage: (file) => request('/meeting/uploadImage', METHOD.POST, file)
}

export default meetingApi
